import { render, staticRenderFns } from "./MyPrincipal.vue?vue&type=template&id=40624cac&scoped=true"
import script from "./MyPrincipal.vue?vue&type=script&lang=js"
export * from "./MyPrincipal.vue?vue&type=script&lang=js"
import style0 from "./MyPrincipal.vue?vue&type=style&index=0&id=40624cac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40624cac",
  null
  
)

export default component.exports